import React from "react";

import {ThemeChildrenContainer, ThemeContainer, ThemeContent} from "./CustomerTheme.styles";
import {Loading} from "../../_defaultComponents/Loading/Loading";
import {CustomerAnnouncementPopup} from "../../customer/customerAnnouncementPopup/CustomerAnnouncementPopup";

export const CustomerTheme = ({content}) => {
    return (
        <ThemeContainer>
            <Loading />
            <CustomerAnnouncementPopup />
            <ThemeContent>
                <ThemeChildrenContainer>{content}</ThemeChildrenContainer>
            </ThemeContent>
        </ThemeContainer>
    );
};
